import React, { Component } from 'react';
import { history } from 'components/App/components/UnauthenticatedApp';

import './Button.module.scss';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class DefaultButton extends Component {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        if (this.props.to) {
            history.push(this.props.to);
        }

        if (this.props.handleClick) {
            this.props.handleClick();
        }

    }

    render() {
        const { title, type, style, noarrow, stretched, small, icon, subTitle, timer, bold, smallIcon, normal, conflict, textStyle } = this.props;

        let ic = icon ? <FontAwesomeIcon icon={icon} styleName={timer ? 'timer-icon' : smallIcon ? 'icon-small' : 'icon'}/> : '';
        return (
            <div onClick={this.handleClick} style={style} styleName={`default ${type ? type : ''} ${normal ? 'normal' : ''} ${stretched ? stretched : ''} ${small ? 'small' : ''} ${timer ? 'timed' : ''} ${bold ? 'bold' : ''}`}>
                {(!noarrow && !timer)&& ic}
                <div styleName='button-text' style={conflict ? { justifyContent: 'space-around', padding: '0 10px', flexDirection: 'row' } : textStyle}>
                    {conflict && <FontAwesomeIcon style={{ color: '#FF4956', fontSize: '14px' }} icon={[ 'fas', 'exclamation-circle' ]} />}
                    <h2 style={conflict ? { fontWeight: '800' } : {}}>{title}</h2>
                    { subTitle ?
                        <p>{subTitle}</p>
                        :
                        ''
                    }
                    {timer && ic}
                </div>
            </div>
        );
    }
}

export default DefaultButton;
